import axios from 'axios'

// 获取按钮权限
export function queryButtonPermission (datas) {
  const url = `/customerLogin/queryButtonPermission`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取问题分类下拉列表
export function getSelectProblemType (datas) {
  const url = `/problemType/getSelectProblemType`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 编辑青豆机器人
export function editRobotChindle (datas) {
  const url = `/robotChindle/editRobotChindle`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取说客机器人列表
export function queryRobotTalkPage (datas) {
  const url = `/robotTalk/queryRobotTalkPage`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 编辑说客机器人
export function editRobotTalk (datas) {
  const url = `/robotTalk/editRobotTalk`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 编辑回显说客机器人
export function editReturnRobotTalk (datas) {
  const url = `/robotTalk/editReturnRobotTalk`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 新增说客机器人
export function addRobotTalk (datas) {
  const url = `/robotTalk/addRobotTalk`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 删除说客机器人
export function deleteRobotTalk (datas) {
  const url = `/robotTalk/deleteRobotTalk`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 查看说客机器人内容
export function viewRobotTalk (datas) {
  const url = `/robotTalk/viewRobotTalk`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 设置推荐
export function setRecommend (datas) {
  const url = `/robotTalk/setRecommend`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 设置颜色
export function setColor (datas) {
  const url = `/robotTalk/setColor`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 手动触发加载
export function getProblemAndInsert (datas) {
  const url = `/robotTalk/getProblemAndInsert`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取机器人推荐排序列表
export function queryRobotRecommendedList (datas) {
  const url = `/robotTalk/queryRobotRecommendedList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 机器人推荐重排序
export function robotRecommendedReSort (datas) {
  const url = `/robotTalk/robotRecommendedReSort`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 设置内外部
export function setInOutVisible (datas) {
  const url = `/robotTalk/setInOutVisible`
  return new Promise((resolve, reject) => {
    axios.put(url, datas).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取所有二级平台列表
export function queryTwoPlatformInfoBase (datas) {
  const url = `/customerPlatform/queryTwoPlatformInfoBase`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/robotManage/index.js